import config from '../../../../config/config';
import { getCandidateToken, clearCandidateSession } from './pspSession';

export const SESSION_EXPIRED_EVENT = 'psp-session-expired';

const NETWORK_ERROR = { status: 0, message: 'Não foi possível se comunicar com o servidor. Tente novamente.' };

/**
 * Generic HTTP helper for PSP endpoints.
 */
const request = async (prefix, path, data = {}, { auth = false } = {}) => {
    const body = { ...data };
    if (auth) {
        body.token = getCandidateToken() || '';
    }

    try {
        const response = await fetch(`${config.endpoints.backend}${prefix}/${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(body)
        });
        const json = await response.json();

        if (json && json.psp_access_denied) {
            clearCandidateSession();
            window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        }
        return json;
    } catch (e) {
        return NETWORK_ERROR;
    }
};

export const pspPost = (path, data = {}, opts = {}) =>
    request('psp/candidates', path, data, opts);

export const portalPost = (path, data = {}, opts = {}) =>
    request('psp/portal', path, data, opts);

export const subscriptionPost = (path, data = {}, opts = {}) =>
    request('psp/subscriptions', path, data, { ...opts, auth: true });

export const candidateApi = {
    register: (data) => pspPost('save', data),
    verifyEmail: (email, code) => pspPost('verifyEmail', { email, code }),
    resendCode: (email, purpose = 'cadastro') =>
        pspPost('resendCode', { email, purpose }, { auth: purpose === 'troca_email' }),
    login: (email, password) => pspPost('login', { email, password }),
    logout: () => pspPost('logout', {}, { auth: true }),
    me: () => pspPost('me', {}, { auth: true }),
    update: (data) => pspPost('update', data, { auth: true }),
    confirmEmailChange: (email, code) => pspPost('confirmEmailChange', { email, code }, { auth: true }),
    forgotPassword: (email, friendly_url) => pspPost('forgotPassword', { email, friendly_url }),
    resetPassword: (token, password) => pspPost('resetPassword', { token, password })
};

export const portalApi = {
    getProcesses: () => portalPost('getprocesses'),
    getVacancies: (filters = {}) => portalPost('getvacancies', filters),
    getVacancyById: (id) => portalPost('getvacancybyid', { id }),
    getFilters: () => portalPost('getfilters')
};

export const subscriptionApi = {
    apply: (vacancy_id) => subscriptionPost('apply', { vacancy_id }),
    check: (vacancy_id) => subscriptionPost('check', { vacancy_id }),
    mySubscriptions: () => subscriptionPost('my-subscriptions', {})
};
